let wallWidth=$("#wallWidth");
let panelGap=$("#panelGap");

let panelCount=0;

$("document").ready(function(){
    $(".box").each(function(){createBox(this)})
});
function createBox(e){
    var h=$(e).data("h")
    ,w=$(e).data("w")
    ,d=$(e).data("d")
    ,px=$(e).data("x")??0
    ,py=$(e).data("y")??0
    ,pz=$(e).data("z")??0
    ,rx=$(e).data("rx")??0
    ,ry=$(e).data("ry")??0
    ,rz=$(e).data("rz")??0;

    $(e).css({
        "width":w,
        "height":h,
        "transform":"rotateX("+rx+") rotateY("+ry+") rotateZ("+rz+") translate3D("+px+"px,"+py+"px,"+pz+"px)"
    });
 
    var m=`    
    <div class="face y-faces bottom-wall" style="height:${d};width:${w};transform:translateY(calc(${h}/2)) rotateX(90deg)"></div>
    <div class="face y-faces top-wall" style="height:${d};width:${w};transform:translateY(calc(${h}/-2)) rotateX(90deg);"></div>
    <div class="face x-faces left-wall" style="height:${h};width:${d};transform:translateX(calc(${w}/-2)) rotateY(90deg);"></div>
    <div class="face x-faces right-wall" style="height:${h};width:${d};transform:translateX(calc(${w}/2)) rotateY(90deg);"></div>
    <div class="face z-faces back-wall" style="height:${h};width:${w};transform:translateZ(calc(${d}/-2))"></div>
    <div class="face z-faces front-wall" style="height:${h};width:${w};transform:translateZ(calc(${d}/2))"></div>
    `;
    
    if($(e).hasClass("shadow"))
    {
        m+=`
            <div class=" back-shadow bottom" style="height:calc(${h}*0.11);width:calc(${w});position:absolute;bottom:0px;transform-origin:bottom;transform:translateZ(calc(-1*${d}/2)) rotateX(90deg);"></div>
        `;
    }
    $(e).append(m)

}



$(".factors").on("change",calculate);
wallWidth.on("change",calculate);
$(".varInput.change").on("change",changeVariable);
$(".varInput.input").on("input",changeVariable);


$("[name='slatWidth'").on("change",function(){
    setVariable("minPanelGap",this.value)
    setVariable("maxPanelGap",this.value == 4.8 ? 12:18)
    setVariable("panelGapValue",this.value)
    setVariable("heightRatio",this.value == 4.8 ? 22.5:10.2)
    
    minGap = this.value;
    panelSpacing = this.value;
    panelPerBox = this.value == 4.8 ? 4 : 2;

    $(".rangeInput").attr("min",this.value)
    $(".rangeInput").attr("max",this.value == 4.8 ? 12:18);
    $(".rangeInput").val(this.value)

    $(".rangeValue").html(`${this.value}&Prime;`).css('marginLeft','0px');
    $(".minLimit").html(`${this.value}&Prime;`)
    $(".maxLimit").html(`${this.value == 4.8 ? 12:18}&Prime;`);
    $("#slatsPerBox").html(panelPerBox);

    calculate();
})


var isUpdating = false;
$("input[name='slatWidth']").on("change",function(event){
    if(isUpdating) return;

isUpdating = true;
var matchHeight=$(this).attr("data-value")
$(`.variant-input[data-value^="${matchHeight}"] label`).click();
isUpdating = false;
})

$("input[name='Slat Width']").on("change",function(){

    if(isUpdating)return;

    isUpdating = true;
    var ht=$(this).val(); 
    ht=ht.replace(/["']/g, "");
    $(`input[name='slatWidth']`).attr("checked",false);
    var ele=$(`input[name='slatWidth'][data-value='${ht}']`);
    $(ele).next("label").click();
    $(ele).attr("checked",true);

    isUpdating = false;

})

$(".rangeInput").on("input",function(){
    let rangeValue=$(this).siblings(".rangeValue");
    var displayUnit=$(this).attr("data-displayunit")
    var rangeValueText=  $(this).val()+displayUnit;

    if($(this).val() == $(this).attr("min"))
    {
        setVariable("rangePointsColorBefore","var(--rangeThumbColor)");
        setVariable("rangePointsColorAfter","var(--rangeTrackColor)");
    }
    else if($(this).val() == $(this).attr("max"))
    {
        setVariable("rangePointsColorBefore","var(--rangeTrackColor)");
        setVariable("rangePointsColorAfter","var(--rangeThumbColor)");
    }
    else{
        setVariable("rangePointsColorBefore","var(--rangeTrackColor)");
        setVariable("rangePointsColorAfter","var(--rangeTrackColor)");
    }

    if($(this).val() - $(this).attr("min")<=0.5)
    {
        $(".minLimit").css("opacity",0);
    }
    else{
        $(".minLimit").css("opacity",1);
    }
    if($(this).attr("max") - $(this).val() <= 1)
    {
        $(".maxLimit").css("opacity",0);
    }
    else{
        $(".maxLimit").css("opacity",1);
    }

    var newVal=(($(this).val()-$(this).attr("min"))/($(this).attr("max")-$(this).attr("min")))*100;
    var newPos=`calc(${newVal}% + (${5 - newVal * 0.25}px))`
    rangeValue.html(rangeValueText);

    rangeValue.css("marginLeft",newPos);
})


function calculate(event)
{
    var width=parseInt(wallWidth.val());
    var panelSpacing=parseFloat(panelGap.val());

    if(!width || width==0 || width=="")
    {
      panelCount=0;
       $("#boxCount").html("");
      $(".quantity").html("");
  $("#quant").val(0);
      
      setVariable("wallWidth","50");
        setVariable("panelCount",50/minGap)
      
     $("#wall").html("");
      return false;
    }

    panelCount=width/panelSpacing;
    var boxCount=Math.ceil(panelCount/panelPerBox);

    $("#boxCount").html((panelCount).toFixed(1));
    $(".quantity").html(boxCount + (boxCount>1?" Boxes":" Box"));
  $("#quant").val(boxCount);
    setVariable("wallWidth",width);
    calibrate();
    addPanels();
}
function changeVariable()
{
    var unit=$(this).data("unit");
    var varName=$(this).data("varname");
    var value=$(this).val();

    setVariable(varName,value+unit);
}

function setVariable(name,value)
{
   document.documentElement.style.setProperty(`--${name}`,value);
}


function calibrate()
{
    var width=wallWidth.val();
    var spacing=panelGap.val();

    // if(width/4.8 > 100)
    // {
    //     panelCount=100*4.8/spacing;
    //     setVariable("panelCount",100)
    // }
    // else{
        panelCount=width/spacing;
        setVariable("panelCount",width/minGap);
    // }

}

function addPanels()
{
    
    panel=$("#tempPanel").html();
    var newPanels="";
    for(var i=1;i<=panelCount;i++)
    {
        newPanels+=panel;
    }

    $("#wall").html(newPanels);
}

wallWidth.on("keydown",onlyNumbers);

$("#cartButton").on("click",function(){
  if(panelCount == 0){
        $("#calcError").show();
  }
  else{
    $("input[name='quantity']").val(parseInt($("#quant").val()));
    $(".add-to-cart").click();
  }
  
})
 $(document).on("click",".slat-modal-trigger",function(){
         if($("#calculator").is(":hidden"))
            $("body,.page-container,.main-content").css("overflow-y","hidden");
          else
            $("body,.page-container,.main-content").css("overflow-y","unset");
          $("#calculator").toggleClass("hidden");
          	
          
          
        })
function onlyNumbers(event) {
        // Get the key code for the pressed key
        const keyCode = event.keyCode || event.which;
        const shiftPressed = event.shiftKey;

        // Allow only numeric keys, backspace, and delete
        if (
            (keyCode >= 48 && keyCode <= 57 && !shiftPressed) || // Numeric keys (0-9)
            (keyCode >= 96 && keyCode <= 105) || // Numeric keypad keys (0-9)
            keyCode === 8 || // Backspace
            keyCode === 46 // Delete
        ) {
            return true; // Allow the input
        } else {
            return false; // Prevent the input
        }
    }